import { Component } from '@angular/core';
import { SentMessageStatistics, MassCommService } from 'src/app/communication/shared';
import { Contact } from 'src/app/contacts/shared/contact.model';

@Component({
  selector: 'wl-profile-contacts-analytics-dialog',
  templateUrl: './profile-contacts-analytics-dialog.component.html',
  styleUrl: './profile-contacts-analytics-dialog.component.less',
    standalone: false
})
export class ProfileContactsAnalyticsDialogComponent {
  showDialog = false;
  loadingStatistics = true;
  contact: Contact;
  statistics: SentMessageStatistics = null;

  constructor(private _massCommService: MassCommService) {}

  async open(contact: Contact) {
    this.contact = contact;
    this.showDialog = true;
    await this._massCommService.getSentMessageStatisticsByContactId(this.contact.ContactId).then((statistics) => {
      this.statistics = statistics;
      this.loadingStatistics = false;
    });
  }

  close() {
    this.showDialog = false;
  }
}
